import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment-timezone';
import 'moment/locale/es';

@Pipe({ name: 'UtcPipe' })
export class UtcPipe implements PipeTransform {
    transform(date: Date, format: string = 'D MMM YYYY'): string {
        const m = moment.utc(date).tz("America/Mexico_City").format(format);
        return m;
    }
}
